function SelectAuto({ children, id, label, value, onChange, filter, onFilter }) {
    return (
        <div class="form-floating mb-2 select-auto">
            <input id={id + "Filter"} type="text" value={filter} onChange={onFilter} placeholder={label} />
            <select class="form-select" id={id} name={id} value={value} onChange={onChange}>
                {children}
            </select>
        </div>
    )
}

export default SelectAuto;